import useFetchInfinite from 'lib/hooks/useFetchInfinite';

import {
  Loader,
  LoadMore,
  NavLink,
  PageHeader,
  Tabs,
  useQueryTabs,
} from '@frontendmentorio/design-system-v2';

import Discord from 'features/shared/Discord';
import SolutionCard from './Card';

export default function Index() {
  const { activeTab, handleChange, options } = useQueryTabs([
    {
      label: 'Feedback requested',
      value: '',
    },
    {
      label: 'All solutions',
      value: 'all',
    },
  ]);

  const {
    data: { data: solutions, meta },
    isLoading,
    setPage,
  } = useFetchInfinite(
    activeTab ? '/api/v3/solutions?filter=all' : '/api/v3/solutions'
  );

  return (
    <>
      <PageHeader heading="Solutions" isSticky>
        <PageHeader.NavLinks>
          <NavLink href="/solutions" isUnderline level="secondary">
            Solutions
          </NavLink>

          <NavLink href="/tags" level="secondary">
            Tags
          </NavLink>

          <NavLink href="/wall-of-fame" level="secondary">
            Wall of Fame
          </NavLink>
        </PageHeader.NavLinks>
      </PageHeader>

      <div className="px-5 py-6">
        <div className="container-xl pb-8">
          <h1 className="sr-only">Latest solutions</h1>

          <div className="flex flex-col gap-5 items-center">
            <Tabs
              activeTab={activeTab}
              ariaLabel="Display solutions that are either requesting feedback or not requesting feedback"
              dropdownClassName="self-start"
              onChange={handleChange}
              options={options}
              tabsClassName="self-start"
            />

            {isLoading && !solutions && <Loader className="py-10" />}

            <ul className="gap-5 grid tablet:grid-cols-2 desktop:grid-cols-3">
              {solutions?.map((solution) => (
                <SolutionCard key={solution.id} solution={solution} />
              ))}
            </ul>

            {meta?.page.next && (
              <LoadMore
                isLoading={isLoading}
                onClick={() => setPage(meta.page.next)}
              />
            )}
          </div>
        </div>

        <Discord />
      </div>
    </>
  );
}
